/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Andrey Dubov
 * @version 1.23.0
 * @since 1.16.0
 */
import ICommonTranslationHeader from '../../types/common/header';

const initTranslationHeader: ICommonTranslationHeader = {
    iconHelp: '',
    iconHelpTooltip: {
        title: '',
        text: '',
    },
    info: {
        link: '',
    },
    linkToSoho: '',
    logoLabel: '',
    logout: '',
    onboarding: '',
    onboardingTooltip: '',
    support: '',
    tab: {
        corporate: '',
        more: '',
        target: '',
        vas: '',
    },
};

export default initTranslationHeader;
